var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7425 7.2825C15.4875 7.1775 15.15 7.125 14.73 7.125H10.77C9.465 7.125 9 7.59 9 8.91V14.715C9 15.15 9.0525 15.4875 9.165 15.75C9.3975 16.29 9.8925 16.5 10.77 16.5H14.73C16.035 16.5 16.5 16.0275 16.5 14.715V8.91C16.5 8.0175 16.29 7.515 15.7425 7.2825ZM13.5 14.8125H12C11.985 14.8125 11.9625 14.8125 11.9475 14.805C11.835 14.7975 11.7375 14.76 11.655 14.685C11.52 14.5875 11.4375 14.43 11.4375 14.25C11.4375 13.9425 11.6925 13.6875 12 13.6875H13.5C13.8075 13.6875 14.0625 13.9425 14.0625 14.25C14.0625 14.5575 13.8075 14.8125 13.5 14.8125Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7426 4.6425V5.25C15.7426 5.6625 15.4051 6 14.9926 6H10.7701C8.85007 6 7.87507 6.9825 7.87507 8.91V15.75C7.87507 16.1625 7.53757 16.5 7.12507 16.5H5.66257C5.36257 16.5 5.12257 16.26 5.12257 15.9675C5.12257 15.6675 5.36257 15.435 5.66257 15.435H7.12507V12.5625H4.50007C2.83507 12.48 1.50757 11.1075 1.50757 9.42V4.6425C1.50757 2.91 2.91757 1.5 4.65757 1.5H12.6001C14.3326 1.5 15.7426 2.91 15.7426 4.6425Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorMobile);
export default __webpack_public_path__ + "97120/static/media/MonitorMobile.c5a91ea2270990133a09f01cacfa4aa4.svg";
export { ForwardRef as ReactComponent };